export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10831.0d235f8d.jpg";